exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".App {\n  font-family: sans-serif;\n  text-align: center;\n}\n\n.inner {\n  overflow: hidden;\n  transition: max-height 0.2s ease;\n}\n", ""]);

// exports
